module.exports = __webpack_public_path__ + "media/images/icons/guitar_pick_gold-ecb468870d1ec7bbf4365fb9994faebd.svg";